import {createUseStyles} from "react-jss";
import {useState} from "react";
import {Badge, Button, Col, FormControl, FormGroup, FormLabel, InputGroup, Modal, Row, Spinner} from "react-bootstrap";
import {AiFillCheckCircle,AiOutlineDelete,AiFillEdit} from 'react-icons/ai';

const useStyles = createUseStyles({
    container:props=>{
        return {
            '& a:nth-child(1)':{
              textDecoration: 'none',
            },
            '& .vid_image': {
                width: '100%',
                height: 180,
                backgroundImage: `url(${props.video?.pictures?.base_link})`,
                backgroundSize: 'cover',
            },
            '& .vid_label':{
                paddingLeft:5,
                paddingRight:5,
                background:'#6c757d',
                color:'white',
            },
            '& .vid_description':{
                paddingLeft:5,
                paddingRight:5,
                fontSize:'.8em',
            }
        }
    },
    videoEmbed:{
        display:'flex',
        justifyContent:'center',
        marginBottom:10,
        '& iframe':{
            width:'100%'
        }
    },
    control:{
        textAlign:'right',
        '& a:link':{
            textDecoration:'none',
            transition:'all 0.2s',
            '&:not(:last-child)':{
                marginRight:10,
            },
            '&:hover':{
                filter: 'brightness(1.3)',
            }
        },

    }
})

const VideoItem = ({video,onUseVideo,onEditVideo,onDeleteVideo}) => {
    const classes = useStyles({video});
    const [show,setShow] = useState(false);

    const controlClick=(type,e)=>{
        e.preventDefault();
        console.log(type);
        switch (type){
            case 'use':
                if(onUseVideo)onUseVideo();
                break
            case 'edit':
                if(onEditVideo)onEditVideo();
                break
            case 'delete':
                if(onDeleteVideo)onDeleteVideo();
                break

        }
    }

    return <>
        <div className={classes.container}>
            <a href="#" onClick={e=> {
                e.preventDefault();
                setShow(true)
            }}>
                <div className='vid_image'>
                    {video.status!='available' &&
                        <Badge bg="warning" className="m-2" style={{fontWeight:400}}>Transcoding... <Spinner size='sm' animation="grow" /></Badge>
                    }
                </div>
                <div className='vid_label'>{video.name}</div>
                {video.description &&
                    <div className='vid_description'>
                        <div>{video.description}</div>
                    </div>
                }
            </a>
            <div className={classes.control}>
                <a href='#' onClick={controlClick.bind(this,'use')}><AiFillCheckCircle color='#198754'/></a>
                <a href='#' onClick={controlClick.bind(this,'edit')}><AiFillEdit color='#bfa10e'/></a>
                <a href='#' onClick={controlClick.bind(this,'delete')}><AiOutlineDelete color='#dc3545'/></a>
            </div>
        </div>
        <Modal show={show} onHide={e=>setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Video: {video.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <InputGroup className="mb-2">
                            <InputGroup.Text>Video ID:</InputGroup.Text>
                            <FormControl disabled value={video.id}/>
                        </InputGroup>
                        <div className={classes.videoEmbed}>
                            <iframe
                                src={video?.player_embed_url}
                                width="100%" height="300" allow="autoplay; fullscreen; picture-in-picture"
                                allowFullScreen="" title={video?.name}></iframe>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormControl onClick={e=>e.target.select()} as="textarea" value={video.embed.html}/>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={e=>setShow(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={e=>{
                    if(onUseVideo)onUseVideo();
                    setShow(false)
                }}>
                    Use this video
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}
export default VideoItem;